import DialogConfirmCancel from '../../../../../components/dialog/DialogConfirm';
import { Typography } from '@mui/material';

const DialogDelete = ({ onCancel, onConfirm, show, type, item, module, loading }) => {
  return (
    <DialogConfirmCancel
      id={`${module}-${type}-modal`}
      open={show}
      onCancel={onCancel}
      onConfirm={onConfirm}
      loading={loading}
      title={type}
      onCloseHeader={true}
      maxWidth='xs'
    >
      <Typography component={'div'}>
        Are you sure you want to {type} the {module} <b>{item}</b>?
      </Typography>
    </DialogConfirmCancel>
  );
};

export default DialogDelete;
